import axios from "axios";
import { URL } from "@/api/global.env";

const apiDefaults = {
    baseURL: `${URL}api`,
    timeout: 120000, 
};

const unauthClient = axios.create({
  baseURL: `${URL}api/accounts`,
  timeout: 120000, 
});


export { unauthClient, apiDefaults, axios };

